<!--
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2026-06-11 11:40:06
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-06-11 14:04:34
 * @FilePath: /designcenter/src/layout/components/HeaderAccountGuest.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <FsTooltip
    ref="accountRef"
    :teleport="false"
    placement="bottom-end"
    trigger="click"
    mobile-conventional
    show-mask
    :mobile-style="{
      top: '50px',
      right: '0',
      left: 'auto',
      width: '288px',
      boxShadow: 'none',
      height: 'calc(100dvh - 50px)',
      padding: '16px',
      background: '#fff',
      borderRadius: '0',
      transform: 'none',
    }"
    @visible-change="handleVisibleChange"
    :offset-y="11"
    :popper-content-style="{
      width: '288px',
      maxWidth: '288px',
      padding: '16px',
      borderRadius: '8px',
    }"
  >
    <a class="account_icon" href="javascript:;">
      <img :src="accountImg" alt="Account" class="iconfont_nav" />
    </a>
    <template #content>
      <div class="guest_account">
        <FsButton type="red" size="mediumSmall" class="guest_account__btn" @click="signIn">Sign In</FsButton>
        <FsButton type="gray" size="mediumSmall" class="guest_account__btn" @click="signUp">Sign Up</FsButton>
      </div>
    </template>
  </FsTooltip>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { handleFsLink } from '@/utils'
import accountImg from '@/assets/images/user.svg?url'

const emit = defineEmits<{
  (e: 'open-change', visible: boolean): void
}>()

const ACCOUNT_OVERLAY_SOURCE = 'account'
const CLOSE_MOBILE_OVERLAYS_EVENT = 'close-mobile-overlays'

const accountRef = ref<{ hide: () => void } | null>(null)

/** 监听移动端遮罩点击，确保右侧账户抽屉可以通过左侧遮罩关闭。 */
const handleMaskClick = (event: MouseEvent) => {
  if ((event.target as HTMLElement)?.classList.contains('fs-tooltip__mobile--mask')) {
    accountRef.value?.hide()
  }
}

/** 打开登录抽屉时关闭目录、本页导航和语言下拉，避免多层叠在一起。 */
const handleOverlayClose = (event: Event) => {
  const source = (event as CustomEvent<{ source?: string }>).detail?.source
  if (source !== ACCOUNT_OVERLAY_SOURCE) accountRef.value?.hide()
}

const handleVisibleChange = (visible: boolean) => {
  emit('open-change', visible)
  if (visible) {
    document.dispatchEvent(
      new CustomEvent(CLOSE_MOBILE_OVERLAYS_EVENT, { detail: { source: ACCOUNT_OVERLAY_SOURCE } })
    )
    document.addEventListener('click', handleMaskClick, true)
  } else {
    document.removeEventListener('click', handleMaskClick, true)
  }
}

onMounted(() => document.addEventListener(CLOSE_MOBILE_OVERLAYS_EVENT, handleOverlayClose))

onBeforeUnmount(() => {
  document.removeEventListener('click', handleMaskClick, true)
  document.removeEventListener(CLOSE_MOBILE_OVERLAYS_EVENT, handleOverlayClose)
})

// Sign In：新开页面，跳转到 {环境域名}/login.html，redirect 为当前页面地址
const signIn = () => {
  const redirect = encodeURIComponent(window.location.href)
  window.open(handleFsLink(`/login.html?redirect=${redirect}`), '_blank')
}

// Sign Up：新开页面，跳转到固定的注册页地址
const signUp = () => {
  window.open('https://www.fs.com/register.html', '_blank')
}
</script>

<style lang="scss" scoped>
.guest_account {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__btn {
    width: 100%;
  }
}

:deep(.fs-button) {
  font-size: 13px !important;
  span {
    font-weight: 600 !important;
  }
}

:deep(.fs-button + .fs-button) {
  margin-left: 0 !important;
  color: #19191a;
  font-weight: 600;
}

.account_icon {
  color: #19191a;
  position: relative;
  display: block;
  border-radius: 4px;

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    transition: background 0.3s ease-in-out;
    z-index: 1;
    border-radius: 4px;
  }

  &:hover {
    text-decoration: none;
    background: unset;

    &::before {
      background: color-mix(in hsl, #fff 40%, transparent);
    }
  }

  .iconfont_nav {
    width: 24px;
    height: 24px;
    border-radius: 4px;
  }
}
</style>

<style lang="scss">
@media screen and (max-width: 768px) {
  .fs-tooltip__mobile--mask {
    inset: 50px 0 0 !important;
  }

  .fs-tooltip__mobile--content {
    width: 288px;
    overflow: hidden;
    box-shadow: none;
    animation: account-guest-slide-in 0.25s ease-out;

    // 关闭改为点遮罩或再次点击头像，不再展示右上角关闭按钮。
    > .iconfont,
    .fs-icon {
      display: none;
    }

    .guest_account {
      width: 100%;
      gap: 12px;
    }

    .guest_account__btn {
      min-height: 40px;
      margin: 0;
    }
  }

  @keyframes account-guest-slide-in {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
}
</style>
